// biome-ignore lint/performance/noBarrelFile: intentional
export {
  type ToSignatureHashErrorType as ToEventHashErrorType,
  toSignatureHash as toEventHash,
} from './toSignatureHash.js'
